(function ($, window, document) {
  function handleOnDocumentReady () {
    var id = window.location.hash.replace('#', '');
    if (id === '') {
      return;
    }
    if (id.indexOf('/') !== -1) {
      return;
    }
    collapseById(id, true)
  }

  function handleAnchorLinkClick (event) {
    var hasToggle = $(this).data('toggle');
    var href = $(this).attr('href');
    // Only handle internal links that aren't BS toggles
    if (!hasToggle) {
      var parts = href.split('#');
      if (parts.length) {
        var anchor = parts[1];
        if (anchor.length) {
          collapseById(anchor, false, event);
        }
      }
    }
  }

  function collapseById (id, hideIfUnmatched, event) {
    if (!id) {
      return;
    }
    var $target = $('#' + id);
    if (!$target.length || !$target.hasClass('js-collapse-content')) {
      return;
    }

    var collapseTitleSelector = '.js-collapse-title';
    var collapseContentSelector = '.js-collapse-content';

    $(collapseContentSelector).each(function () {
      if ($(this).attr('id') === id) {
        if (event) {
          event.preventDefault();
        }
        $(this).prev(collapseTitleSelector).removeClass('collapsed').attr('aria-expanded', true);
        $(this).addClass('in').attr('aria-expanded', true).css('height', 'auto');
        setTimeout(function () {
          $('html, body').animate({
            scrollTop: $target.prev(collapseTitleSelector).offset().top - 25
          }, 1000);
        }, 100);
      } else {
        if (hideIfUnmatched) {
          $(this).prev(collapseTitleSelector).addClass('collapsed').attr('aria-expanded', false);
          $(this).removeClass('in');
        }
      }
    });
  }

  function handleAnchorLinkKey (event) {
    if (event.which == 13) {
      $(this).children('a.collapse-title').click()
    }
  }

  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", handleOnDocumentReady);
  } else {
    handleOnDocumentReady();
  }
  $('a[href*="#"]', document).on('click', handleAnchorLinkClick);
  $('h3.accordion__item__title', document).on('keyup', handleAnchorLinkKey);

})(jQuery, window, document);
